import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>SunKissedDelight | India's First Vitamin D Chocolate</title>
        <meta
          name="description"
          content="SunKissedDelight by Eykam Wellness – India’s first Vitamin D chocolate. Combining science with indulgence to make health taste good."
        />
        <meta name="author" content="Eykam Wellness" />
        <meta
          name="keywords"
          content="Vitamin D, chocolate supplement, sugar free, Eykam Wellness, SunKissed Delight"
        />
        <meta name="author" content="Eykam Wellness" />
        <link rel="canonical" href="https://sunkisseddelight.com/" />
        <meta name="robots" content="index, follow" />
        <meta property="og:site_name" content="SunKissedDelight" />
        <meta property="og:url" content="https://sunkisseddelight.com" />
        <meta
          property="og:title"
          content="SunKissedDelight | Vitamin D Chocolate"
        />
        <meta
          property="og:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:image"
          content="https://sunkisseddelight.com/static/media/Sun%20Image%20(SKD).f6e12506ff4d8b1649c2642c05df9c07.svg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="SunKissedDelight | Vitamin D Chocolate"
        />
        <meta
          name="twitter:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
        <meta
          name="twitter:image"
          content="https://sunkisseddelight.com/static/media/Sun%20Image%20(SKD).f6e12506ff4d8b1649c2642c05df9c07.svg"
        />

        <meta
          name="google-site-verification"
          content="+nxGUDJ4QpAZ5l9Bsjdi102tLVC21AIh5d1Nl23908vVuFHs34="
        />
      </Helmet>
      <div id="qodef-page-outer">
        <div id="qodef-page-inner" className="qodef-content-full-width">
          <main
            id="qodef-page-content"
            className="qodef-grid qodef-layout--template"
          >
            <div className="qodef-grid-inner clear">
              <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
                <div
                  data-elementor-type="wp-page"
                  data-elementor-id={60}
                  className="elementor elementor-60"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <div
                        style={{ height: "100%" }}
                        className="qodef-page-title qodef-m qodef-title--standard qodef-alignment--left qodef-vertical-alignment--header-bottom qodef--has-image qodef-image--parallax qodef-parallax"
                      >
                        <div
                          className="qodef-m-inner"
                          style={{ background: "#2e1209" }}
                        >
                          <div
                            className="qodef-parallax-img-holder"
                            style={{ opacity: 1 }}
                          >
                            <div className="qodef-parallax-img-wrapper">
                              <img
                                src={`https://res.cloudinary.com/dgne9mq7j/image/upload/v1748785471/website_banner_qtr6mu.webp`}
                                className="qodef-parallax-img"
                                alt="k"
                                decoding="async"
                                sizes="(max-width: 1920px) 100vw, 1920px"
                                style={{
                                  height: "100%",
                                  width: "100vw",
                                  maxWidth: "unset",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex-50">
                            <div className="wrapper">
                              <div className="components">
                                <h2 style={{ color: "#fff" }}>
                                  Skip the Pills. Get Your Vitamin D in
                                  Chocolate.
                                </h2>
                                <p>
                                  Your convenient weekly dose—deliciously easy
                                  and trusted by doctors. Say goodbye to tablets
                                  and sachets. Say hello to Vitamin D chocolate
                                  that works.
                                </p>
                                <Link to={`/Products`}>
                                  <button>Shop Now</button>
                                </Link>
                              </div>
                              <div className="components"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-0f9ffc9 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="0f9ffc9"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-81c4b21"
                              data-id="81c4b21"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div style={{ width: "100vw" }}>
                                  <div
                                    className="elementor-element elementor-element-7871ffe elementor-widget__width-initial elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="7871ffe"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--center qodef-appear-animation--enabled">
                                        <h3
                                          style={{
                                            color: "#38190E",
                                            fontWeight: "800",
                                          }}
                                        >
                                          Why Choose Sun Kissed Delight?
                                        </h3>
                                        <p>
                                          A smarter, tastier way to get your
                                          Vitamin D—created to make wellness
                                          simple, effective, and joyful.
                                        </p>
                                        <div className="qodef-m-button">
                                          <a
                                            className="qodef-shortcode qodef-m qodef-button qodef-layout--filled qodef-html--link qodef-has-icon qodef-no-text"
                                            href="/#"
                                            target="_self"
                                          >
                                            <span className="qodef-m-text">
                                              <svg
                                                className="qodef-m-svg-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                width="35.375px"
                                                height="11.125px"
                                                viewBox="0 0 35.375 12.125"
                                                enableBackground="new 0 0 35.375 12.125"
                                                xmlSpace="preserve"
                                              >
                                                <g>
                                                  <line
                                                    x1="0.198"
                                                    y1="6.078"
                                                    x2="35.088"
                                                    y2="6.047"
                                                  />
                                                  <line
                                                    x1="29.823"
                                                    y1={1}
                                                    x2="34.745"
                                                    y2="5.922"
                                                  />
                                                  <line
                                                    x1="29.823"
                                                    y1="11.125"
                                                    x2="34.745"
                                                    y2="6.203"
                                                  />
                                                </g>
                                              </svg>{" "}
                                            </span>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-fe7d420 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="fe7d420"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2784e54 w-50"
                              data-id="2784e54"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-64dbb60 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                    data-id="64dbb60"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_image_with_text.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                        <div className="qodef-m-image">
                                          <a
                                            itemProp="url"
                                            href="/#"
                                            target="_self"
                                          >
                                            <img
                                              loading="lazy"
                                              decoding="async"
                                              width={138}
                                              height={138}
                                              src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386764/2_bpxiq9.webp"
                                              className="attachment-full size-full"
                                              alt="f"
                                              sizes="auto, (max-width: 138px) 100vw, 138px"
                                            />
                                          </a>
                                        </div>
                                        <div className="qodef-m-content">
                                          <h5 className="qodef-m-title">
                                            <a
                                              itemProp="url"
                                              href="/#"
                                              target="_self"
                                            >
                                              Better Absorption
                                            </a>
                                          </h5>
                                          <p className="qodef-m-text">
                                            Over 2x absorption compared to
                                            traditional Vitamin D sachets (based
                                            on in-house trials)
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-318d51d w-50"
                              data-id="318d51d"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-c3654596 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                    data-id="c3654596"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_image_with_text.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                        <div className="qodef-m-image">
                                          <a
                                            itemProp="url"
                                            href="/#"
                                            target="_self"
                                          >
                                            <img
                                              loading="lazy"
                                              decoding="async"
                                              width={138}
                                              height={138}
                                              src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386764/1_n1vqbr.webp"
                                              className="attachment-full size-full"
                                              alt="e"
                                              sizes="auto, (max-width: 138px) 100vw, 138px"
                                            />
                                          </a>
                                        </div>
                                        <div className="qodef-m-content">
                                          <h5 className="qodef-m-title">
                                            <a
                                              itemProp="url"
                                              href="/#"
                                              target="_self"
                                            >
                                              Convenient Weekly
                                            </a>
                                          </h5>
                                          <p className="qodef-m-text">
                                            No daily hassle—just one chocolate a
                                            week or month, depending on your
                                            needs
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-563ab28"
                              data-id="563ab28"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-ee806d6 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                    data-id="ee806d6"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_image_with_text.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                        <div className="qodef-m-image">
                                          <a
                                            itemProp="url"
                                            href="/#"
                                            target="_self"
                                          >
                                            <img
                                              loading="lazy"
                                              decoding="async"
                                              width={138}
                                              height={138}
                                              src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386765/5_yifqps.webp"
                                              className="attachment-full size-full"
                                              alt="f"
                                              sizes="auto, (max-width: 138px) 100vw, 138px"
                                            />
                                          </a>
                                        </div>
                                        <div className="qodef-m-content">
                                          <h5 className="qodef-m-title">
                                            <a
                                              itemProp="url"
                                              href="/#"
                                              target="_self"
                                            >
                                              Kid and Adult Friendly
                                            </a>
                                          </h5>
                                          <p className="qodef-m-text">
                                            Loved by kids, trusted by adults—no
                                            more struggles with pills or powders
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-fe7d420 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="fe7d420"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2784e54 w-50"
                              data-id="2784e54"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-64dbb60 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                    data-id="64dbb60"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_image_with_text.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                        <div className="qodef-m-image">
                                          <a
                                            itemProp="url"
                                            href="/#"
                                            target="_self"
                                          >
                                            <img
                                              loading="lazy"
                                              decoding="async"
                                              width={138}
                                              height={138}
                                              src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386766/4_gkygqz.webp"
                                              className="attachment-full size-full"
                                              alt="f"
                                              sizes="auto, (max-width: 138px) 100vw, 138px"
                                            />
                                          </a>
                                        </div>
                                        <div className="qodef-m-content">
                                          <h5 className="qodef-m-title">
                                            <a
                                              itemProp="url"
                                              href="/#"
                                              target="_self"
                                            >
                                              Sugar-Free Options
                                            </a>
                                          </h5>
                                          <p className="qodef-m-text">
                                            Enjoy guilt-free indulgence with
                                            diabetic-friendly choices
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-318d51d w-50"
                              data-id="318d51d"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-c3654596 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                    data-id="c3654596"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_image_with_text.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                        <div className="qodef-m-image">
                                          <a
                                            itemProp="url"
                                            href="/#"
                                            target="_self"
                                          >
                                            <img
                                              loading="lazy"
                                              decoding="async"
                                              width={138}
                                              height={138}
                                              src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386764/3_vernt6.webp"
                                              className="attachment-full size-full"
                                              alt="e"
                                              sizes="auto, (max-width: 138px) 100vw, 138px"
                                            />
                                          </a>
                                        </div>
                                        <div className="qodef-m-content">
                                          <h5 className="qodef-m-title">
                                            <a
                                              itemProp="url"
                                              href="/#"
                                              target="_self"
                                            >
                                              Doctor-Recommended
                                            </a>
                                          </h5>
                                          <p className="qodef-m-text">
                                            Designed for real-life compliance
                                            and doctor-backed dosing sweetness
                                            for special
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-318d51d"
                              data-id="318d51d"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-c365459 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                    data-id="c365459"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_image_with_text.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                        <div className="qodef-m-image">
                                          <a
                                            itemProp="url"
                                            href="/#"
                                            target="_self"
                                          >
                                            <img
                                              loading="lazy"
                                              decoding="async"
                                              width={138}
                                              height={138}
                                              src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386767/6_rkplpl.webp"
                                              className="attachment-full size-full"
                                              alt="e"
                                              sizes="auto, (max-width: 138px) 100vw, 138px"
                                            />
                                          </a>
                                        </div>
                                        <div className="qodef-m-content">
                                          <h5 className="qodef-m-title">
                                            <a
                                              itemProp="url"
                                              href="/#"
                                              target="_self"
                                            >
                                              Eco Friendly
                                            </a>
                                          </h5>
                                          <p className="qodef-m-text">
                                            100 % Eco Friendly  packaging
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-0f9ffc1 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="0f9ffc1"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div
                            className="elementor-row"
                            style={{ overflow: "auto" }}
                          >
                            <table
                              className="shop_table cart wishlist_table wishlist_view traditional responsive   "
                              data-pagination="no"
                              data-per-page={5}
                              data-page={1}
                              data-id=""
                              data-token=""
                            >
                              <thead>
                                <tr>
                                  <th className="product-price">
                                    <center>
                                      <h5>Feature </h5>
                                    </center>
                                  </th>
                                  <th className="product-price">
                                    <center>
                                      <h5>SunkissedDelight </h5>
                                    </center>
                                  </th>
                                  <th className="product-price">
                                    <center>
                                      <h5>Sachets </h5>
                                    </center>
                                  </th>
                                  <th className="product-price">
                                    <center>
                                      <h5>Pills</h5>
                                    </center>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="wishlist-items-wrapper">
                                <tr id="yith-wcwl-row-4075" data-row-id="4075">
                                  <td className="product-remove">
                                    <div>Tastes Good</div>
                                  </td>

                                  <td className="product-price">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="#ECC269"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                    </svg>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                                <tr id="yith-wcwl-row-4075" data-row-id="4075">
                                  <td className="product-remove">
                                    <div>Easy to Take</div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                                <tr id="yith-wcwl-row-4075" data-row-id="4075">
                                  <td className="product-remove">
                                    <div>Suitable for All Ages</div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                                <tr id="yith-wcwl-row-4075" data-row-id="4075">
                                  <td className="product-remove">
                                    <div>Better Absorption</div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      {" "}
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                                <tr id="yith-wcwl-row-4075" data-row-id="4075">
                                  <td className="product-remove">
                                    <div>Sugar-Free Option Available</div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                                <tr id="yith-wcwl-row-4075" data-row-id="4075">
                                  <td className="product-remove">
                                    <div>Doctor-Recommended</div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      {" "}
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                                <tr id="yith-wcwl-row-4075" data-row-id="4075">
                                  <td className="product-remove">
                                    <div>Coolness Level </div>
                                  </td>

                                  <td className="product-price">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="#ECC269"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M12 17.27L18.18 21 16.54 13.97 22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z" />
                                    </svg>
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="#ECC269"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M12 17.27L18.18 21 16.54 13.97 22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z" />
                                    </svg>
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="#ECC269"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M12 17.27L18.18 21 16.54 13.97 22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z" />
                                    </svg>
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="#ECC269"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M12 17.27L18.18 21 16.54 13.97 22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z" />
                                    </svg>
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="#ECC269"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M12 17.27L18.18 21 16.54 13.97 22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z" />
                                    </svg>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="#ECC269"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M12 17.27L18.18 21 16.54 13.97 22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z" />
                                      </svg>
                                    </div>
                                  </td>

                                  <td className="product-price">
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <line
                                          x1="6"
                                          y1="6"
                                          x2="18"
                                          y2="18"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                        <line
                                          x1="6"
                                          y1="18"
                                          x2="18"
                                          y2="6"
                                          stroke="#FFFFFF"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                        />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </section>
                      <br />
                      <br />
                      <center>
                        <h3>
                          <b>Find Us</b>
                        </h3>
                      </center>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-0494c78 elementor-section-full_width elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="0494c78"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row img_box">
                            <div className="Image_container">
                              <div className="item">
                                <a
                                  itemProp="url"
                                  href="https://www.instagram.com/eykam__wellness/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={750}
                                    src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386407/3_xwqi62.webp"
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                              <div className="item">
                                <a itemProp="url" href="#/">
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={780}
                                    src={
                                      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746466066/IMG_9951_kawqau.webp"
                                    }
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                              <div className="item">
                                <a itemProp="url" href="#/">
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={780}
                                    src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386407/2_fky4bw.webp"
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                              <div className="item">
                                <a itemProp="url" href="#/">
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={780}
                                    src={
                                      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746466138/IMG_0038_en0l5y.webp"
                                    }
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                              <div className="item">
                                <a itemProp="url" href="#/">
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={780}
                                    src={
                                      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746466143/IMG_9879_zqtahs.webp"
                                    }
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                              <div className="item">
                                <a
                                  itemProp="url"
                                  href="https://www.facebook.com/profile.php?id=61560025850257"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={780}
                                    src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386407/1_mg8vpp.webp"
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                              <div className="item">
                                <a itemProp="url" href="#/">
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={780}
                                    src={
                                      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746466149/IMG_9999_l8zema.webp"
                                    }
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                              <div className="item">
                                <a
                                  itemProp="url"
                                  href="https://www.linkedin.com/company/eykam-wellness/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={800}
                                    height={780}
                                    src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747386407/4_sqhur9.webp"
                                    className="attachment-full size-full"
                                    alt="w"
                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        {/* close #qodef-page-inner div from header.php */}
      </div>
    </>
  );
};

export default Home;
